export default __webpack_public_path__ + "static/media/Photonics.7d9aa31b.png";